import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

import { UserService } from '@core/services/user.service';
import { CurrentUser } from '@core/models/current-user';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
	selector: 'kwo-account-profile',
	templateUrl: './account-profile.component.html',
	styleUrls: ['./account-profile.component.scss'],
	standalone: true,
	imports: [CommonModule, TranslateModule, FaIconComponent],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountProfileComponent implements OnInit {

	mandateActive: boolean = false;

	user: CurrentUser | null;

	constructor(private snackBar: MatSnackBar,
		private router: Router,
		public dialog: MatDialog,
		public userService: UserService) {

		this.user = new CurrentUser();
	}

	ngOnInit(): void {

		this.user = this.userService.getUser();
		if (this.user && this.user.subscription.dunning) {

			this.showMessage();
		}
	}

	goToAccount() {

		this.router.navigate(['/account']);
	}

	goToLogin() {

		this.router.navigate(['/inloggen']);
	}

	showMessage() {

		let snackBarRef = this.snackBar.open('Je betaling is mislukt. Wil je blijven kijken?', 'Behoud toegang', {
			panelClass: ['kwo-snackbar', 'alert'],
			duration: undefined
		});
	}
}